import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "首页", -1);
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "推广", -1);
const _hoisted_4 = {
  key: 0,
  src: "https://video-h5.wqxsw.com/ttyd/img/list-active.png"
};
const _hoisted_5 = {
  key: 1,
  src: "https://video-h5.wqxsw.com/ttyd/img/list.png"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "数据", -1);
const _hoisted_7 = {
  key: 0,
  src: "https://video-h5.wqxsw.com/ttyd/img/table-active.png"
};
const _hoisted_8 = {
  key: 1,
  src: "https://video-h5.wqxsw.com/ttyd/img/table.png"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "我的", -1);
const _hoisted_10 = {
  key: 0,
  src: "https://video-h5.wqxsw.com/ttyd/img/mine-active.png"
};
const _hoisted_11 = {
  key: 1,
  src: "https://video-h5.wqxsw.com/ttyd/img/mine.png"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view, null, {
    default: _withCtx(_ref => {
      let {
        Component
      } = _ref;
      return [(_openBlock(), _createBlock(_KeepAlive, null, [_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
        key: _ctx.$route.name
      })) : _createCommentVNode("", true)], 1024)), !_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
        key: _ctx.$route.name
      })) : _createCommentVNode("", true)];
    }),
    _: 1
  }), $setup.isShowTab ? (_openBlock(), _createBlock(_component_van_tabbar, {
    key: 0,
    route: "",
    "safe-area-inset-bottom": "",
    placeholder: "",
    "active-color": "#258CFF",
    "inactive-color": "#999999"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      to: "/home"
    }, {
      icon: _withCtx(props => [_createElementVNode("img", {
        src: props.active ? 'https://video-h5.wqxsw.com/ttyd/img/home-active.png' : 'https://video-h5.wqxsw.com/ttyd/img/home.png'
      }, null, 8, _hoisted_2)]),
      default: _withCtx(() => [_hoisted_1]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      to: "/list"
    }, {
      icon: _withCtx(props => [props.active ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), !props.active ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true)]),
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      to: "/tdata"
    }, {
      icon: _withCtx(props => [props.active ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : _createCommentVNode("", true), !props.active ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : _createCommentVNode("", true)]),
      default: _withCtx(() => [_hoisted_6]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      to: "/mine"
    }, {
      icon: _withCtx(props => [props.active ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true), !props.active ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : _createCommentVNode("", true)]),
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true)], 64);
}